import React from 'react';
import {
    CheckCircleFilled,
    CopyOutlined,
    DeleteOutlined,
    EditOutlined,
    ExclamationCircleOutlined,
} from '@ant-design/icons';
import { normalizePpaTableRowAction, PpaTableRowAction } from 'types/ppa';

export const getActionIcon = (actionLabel: string) => {
    const action = normalizePpaTableRowAction(actionLabel);
    if (action === PpaTableRowAction.Edit) {
        return <EditOutlined className="text-[16px]" />;
    }
    if (action === PpaTableRowAction.Duplicate) {
        return <CopyOutlined className="text-[16px]" />;
    }
    if (action === PpaTableRowAction.Delete) {
        return <DeleteOutlined className="text-[16px]" />;
    }
    return null;
};

export const scenarioDeleteConfirmIcon = (
    <ExclamationCircleOutlined style={{ color: '#FF4D4F' }} />
);

export const scenarioDeleteSuccessIcon = (
    <CheckCircleFilled style={{ position: 'relative', top: -3, color: '#52C41A' }} />
);
